import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { PageTopBanner } from "app/components/PageTopBanner/PageTopBanner";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

export const DigitalMarketingContainer = () => {
    // TODO: auto scroll top
    const { state, params } = useCurrentStateAndParams();

    return (
        <div className="sw-layout-module-inner">
            <span
                className="u-flex-row u-flex-column"
                style={{ flexGrow: 1, overflowX: "hidden", width: "100%" }}
            >
                <ErrorBoundary
                    FallbackComponent={ErrorFallback}
                    resetKeys={[state, params]}
                >
                    <PageTopBanner />
                    <UIView className="sw-layout-research disable-top-padding use-sticky-css-rendering fadeIn" />
                </ErrorBoundary>
            </span>
        </div>
    );
};
